/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Modal, ModalBody, ModalHeader } from 'bold-ui'
import { AlertaSuporteDecisaoClinica } from 'hooks/sdc/model-sdc'

import { ReactComponent as SdcIcon } from '../../../images/suporte-decisao-clinica/health-system-outline.svg'
import { SdcDetalhesModalBody } from './SdcDetalhesModalBody'
import { SdcDetalhesModalSideMenu } from './SdcDetalhesModalSideMenu'

interface SdcDetalhesModalProps {
  isModalOpen: boolean
  onClose: () => void
  alertaSelecionado: AlertaSuporteDecisaoClinica
}

// TODO@CODEBENDERS substituir o modal atual do SDC pelo novo modal do Bold com header fixo quando for disponibilizado #24923
export const SdcDetalhesModal = (props: SdcDetalhesModalProps) => {
  const { isModalOpen, onClose, alertaSelecionado } = props

  return (
    <Modal open={isModalOpen} onClose={onClose} size='auto' closeOnBackdropClick={false} style={styles.modalContainer}>
      <ModalHeader title='Suporte à Decisão Clínica' icon={SdcIcon} />
      <SdcDetalhesModalSideMenu position='left' alertaSelecionado={alertaSelecionado} />
      <ModalBody style={styles.modalBody}>
        <SdcDetalhesModalBody alertaSelecionado={alertaSelecionado} />
      </ModalBody>
    </Modal>
  )
}

const styles = {
  modalContainer: css`
    display: flex;
    flex-direction: column;
    height: 45rem;
  `,
  modalBody: css`
    padding: 0;
  `,
}
